import type * as React from 'react';
import { put } from '@Domain/Api';
import organizationWorkflowOptionsSaved, {
	type OrganizationWorkflowOptionsSavedAction,
} from '@Application/Organizations/Workflows/Actions/organizationWorkflowOptionsSaved';
import organizationWorkflowOptionsSaveFailed, {
	type OrganizationWorkflowOptionsSaveFailedAction,
} from '@Application/Organizations/Workflows/Actions/organizationWorkflowOptionsSaveFailed';
import type { OrganizationWorkflowPayload } from '@Application/Organizations/Workflows/Actions/organizationWorkflowsFetched';
import type SaveOrganizationWorkflowOptions from '@Application/Organizations/Workflows/Commands/SaveOrganizationWorkflowOptions';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = OrganizationWorkflowOptionsSavedAction | OrganizationWorkflowOptionsSaveFailedAction;

export default (command: SaveOrganizationWorkflowOptions) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const response = await put<OrganizationWorkflowPayload>(
				`${parameters.api.host}/api/organizations/${command.organizationId}/workflows/${command.workflowKey}/options`,
				command.toJSON(),
			);

			const action = organizationWorkflowOptionsSaved(response, command.organizationId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = organizationWorkflowOptionsSaveFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
